import { useTranslation } from 'react-i18next';

import useAiChatToolLabel from '../../hooks/useAiChatToolLabel';
import useAiChatToolStatus from '../../hooks/useAiChatToolStatus';
import AiChatToolCard from '../AiChatToolCard';

import type { ReactElement } from 'react';
import type { IAiChatToolCallOf } from '../../interfaces/IAiChatToolCall';

/** The `lookupPublicCompany` tool call: public facts for a Watch Tower seed. */
function LookupPublicCompanyToolCall({
  part,
}: IAiChatToolCallOf<'lookupPublicCompany'>): ReactElement {
  const { t } = useTranslation();
  const label = useAiChatToolLabel('lookupPublicCompany');
  const status = useAiChatToolStatus(part.state);

  const lookupCount = part.state === 'output-available'
    ? (part.output.companies?.length || (part.output.facts.name ? 1 : 0))
    : 0;
  const lookupError = part.state === 'output-available' ? part.output.error : undefined;

  let summary = status;
  if (part.state === 'output-available') {
    if (lookupCount > 1) {
      summary = t('aiChat.tools.publicCompaniesLookedUp', { count: lookupCount });
    } else {
      summary = t(part.output.facts.name
        ? 'aiChat.tools.publicCompanyLookedUp'
        : 'aiChat.tools.publicCompanyLookupMiss');
    }
  }

  return (
    <AiChatToolCard name={label} status={summary} errorText={part.errorText || lookupError}>
      {part.input?.name || part.input?.query}
    </AiChatToolCard>
  );
}

export default LookupPublicCompanyToolCall;
